import * as yup from 'yup';

export const KnowledgeDomainFormValidation = yup.object().shape({
    description: yup.string().required('Nome é obrigatória'),
    code: yup.string().required('Campo é obrigatória'),
    status: yup.bool().default(true),
});